module.exports = __webpack_public_path__ + "static/media/cq_richieste b.b2fe447c.svg";